<template>
	<div class="footer" >
		<div class="layui-container">
			<div class="foot-main">
				<div class="foot-logo">
					<div class="foot-logo-box">
						<img :src="$helper.get('rule').app_logo" alt="">
					</div>
					<div class="foot-link-box">
						<a class="e-link" href="http://online.gov.vn/Home/WebDetails/124522" target="_blank">
							<img src="../../../assets/images/etr.png" alt="" />
						</a>
					</div>
				</div>
				<div class="foot-cell foot-cell-navbar">
					<div class="foot-nav-hd">
						{{$t('服务政策')}}
					</div>
					<ul class="foot-nav" v-if="footNav.length > 0">
						<li >
							<router-link to="/about" >
								{{ $t('关于我们') }}
							  </router-link>
						</li>
						<li v-for="(item,index) in footNavs2" :key="`m${index}`">
							<router-link :to="item.is_nav == 1 ? '/about?pageid=' + item.id : '/explain?pageid=' + item.id" :key="$route.fullPath">
								{{ $t(item.title) }} 
							  </router-link>
						</li>
						<li v-for="(item,index) in footNav" :key="`m2${index}`">
							<router-link :to="item.is_nav == 1 ? '/about?pageid=' + item.id : '/explain?pageid=' + item.id" :key="$route.fullPath">
								{{ $t(item.title) }}
							  </router-link>
						</li>
					</ul>
				</div>
				<div class="foot-cell foot-info-cell">
					<div class="foot-nav-hd">
						{{$t('联系我们')}}</div>
					<div class="foot-item">
						<span class="iconfont icon-ditu"></span><span>
							{{ $t(spRules.address) }}
						</span>
					</div>
					<div class="foot-item">
						<span class="iconfont icon-tel"></span><span>{{ spRules.phone }}</span>
					</div>
					<div class="foot-item">
						<span class="iconfont icon-email"></span><span>{{ spRules.email }}</span>
					</div>
				</div>
				<div class="foot-company-cell">
					<div class="foot-item">
						<span class="iconfont icon-jianzhu"></span>
						<span>
							{{ replacedString }}
						</span>
					</div>
				</div>
			</div>
			<div class="copyright">
				{{ spRules.copyright }}
				
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			footNav: {
				type: Array,
				default: () => [],
			},
			footNavs2: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				originalString: this.$t('公司信息'),
				spRules: {},
			};
		},
		computed: {
		    replacedString() {
		      return this.originalString.replace(/B&amp;B/g, 'B&B');
		    },
		},
		methods:{
		},
		mounted() {
			this.spRules = this.$helper.get('rule');
		}
	}
</script>
